var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 10.628v3.292h5.445c-.221 1.414-1.647 4.14-5.445 4.14-3.277 0-5.951-2.714-5.951-6.06 0-3.345 2.674-6.06 5.95-6.06 1.865 0 3.114.796 3.827 1.481l2.606-2.509C16.95 3.345 14.782 2.4 12.192 2.4A9.595 9.595 0 002.59 12c0 5.307 4.294 9.6 9.6 9.6 5.54 0 9.218-3.896 9.218-9.38 0-.63-.067-1.109-.15-1.59l-9.068-.003h-.001z"
  })));
}
export default SvgGoogle;